import React from 'react';

import './multiple-sku-list.scss';

const MultipleSkuList = ({
  product = {},
  activeSkuIndex = 0,
  setActiveSkuIndex = () => {},
}) => {
  const { skus } = product;
  if (!skus?.length) return null;

  return (
    <>
      {skus?.map((item, index) => {
        const activeSku = index === activeSkuIndex;
        let styleObject = activeSku
          ? 'multiple-sku-list--inventory-available-selected'
          : 'multiple-sku-list--inventory-available-not-selected';

        if (!item?.isInventoryAvailable)
          styleObject = `${styleObject} multiple-sku-list--opacity`;

        return (
          <div
            className={`multiple-sku-list--container ${styleObject}`}
            onClick={() => {
              setActiveSkuIndex(index);
            }}
          >
            <div className="multiple-sku-list--product-sku-textstyle">
              {item?.quantity}
            </div>
            {item?.subText && (
              <div className="multiple-sku-list--product-cuts-textstyle">
                {item?.subText}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default MultipleSkuList;
